namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailOrganizacniJednotkaNew extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GOrganizacniJednotkaReadDto;
        private newRecord: boolean;
        private detailObj: DetailOrganizacniJednotkaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private adxCheckIcoNad: number;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailOrganizacniJednotkaObj());
            this.detailObj.createBase({
                contentName: "detailOrganizacniJednotkaNew",
                contentCaption: "jres:29802620",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.adxCheckIcoNad = this.adxCheckIcoNad;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailOrganizacniJednotkaNew", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailOrganizacniJednotkaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GOrganizacniJednotkaReadDto> {
        adxCheckIcoNad: number;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_orj) ? this.data.ixs_orj.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GOrganizacniJednotkaSaveDto, close: boolean) {
            (this.cnt.isl.OrganizacniJednotka.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsorj");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailOrganizacniJednotkaNew", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.OrganizacniJednotka.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actOpenSslDenik*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSslDenik: {
                    icon: "fa-link",
                    caption: "jres:29808097", //RC 29808097 : Deníky povolené pro organizační jednotku 
                    run: (ev, ctx) => {
                        Gordic.Adm.WebControls.OrganizacniJednotka.openSeznamOrganizacniJednotkaDenikSsl(this.data);
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenSslDenik?.update({ enabled: editMode == false })
        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            })

            this.MakeFields("ixs_orj,zkratka,nazev,ofic_nazev")
            this.MakeField("kod_orj");
            this.MakeSelectField("uroven_orj", Gordic.Prefabs.Select.gincorj())
            this.MakeField("poznamka")

            // políčko FUN je datově závislé na ICO - toto je varianta přes závislost políček - obecnější ale pracnější
            //this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
            //    model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun", 
            //    serverFilters: {
            //        IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.element),
            //        aktivita: null,
            //        VcetneNullFunkce: true,
            //        VcetneServisnichFunkci: true
            //    }, dropdown: false,
            //})

            // políčko FUN je datově závislé na ICO - toto je varianta přes závislost na instanční proměnné detail okna - jednodušší - počítá s tím, že celé okno patří k jednomu IČO což je pro ADM pravda
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun",
                initialValue: { ico: this.data.ico },
                serverFilters: {
                    IcoOrSharedIco: this.data.ico,
                    aktivita: null,
                    VcetneNullFunkce: true,
                    VcetneServisnichFunkci: true
                },
                dropdown: false,
            })

            // GetDatabaseParameter("adx_checkiconad", 0) == 1
            if (this.adxCheckIcoNad === 1) {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginsorj(), {
                    model: "model.ico=>value.ico,model.ixs_nad=value.ixs_orj",
                    serverFilters: {
                        IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                        aktivita: null
                    },
                    dropdown: false,
                })
            }
            else {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginsorj(), {
                    model: "model.ixs_nad=value.ixs_orj",
                    serverFilters: {
                        aktivita: null
                    },
                    dropdown: false,
                })
            }

            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ico=>value.ico,model.ixs_su=value.ixs_su",
                serverFilters: {
                    IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                    aktivita: null
                },
                dropdown: false,
            })
            this.MakeField("mail")
            this.MakeField("tel")
            this.MakeField("fax")
            this.MakeSelectField("ixs_isu", Gordic.Prefabs.Select.ginsesu(), {
                model: "model.ico=>value.ico,model.ixs_isu=value.ixs_esu",
                serverFilters: {
                    IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                    aktivita: null,
                    priz_int: 10
                },
                dropdown: false,
            })

            this.MakeField("dat_od")
            this.MakeField("dat_do")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt())
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}